import React, { useState } from "react";

import ModalConditionsComponent from "./ModalConditionsComponent";

function SwitchComponent(props) {

    const [showModal, setShowModal] = useState(false);
    const [conditionChecked, setConditionChecked] = useState(false);

    const handleChange = (e) => {
        const checked = e.target.checked;
        props.onSwitchChange(checked);
        setConditionChecked(checked);
    };

    const handleTerms = () => {
        if (!props.disabled)
            setShowModal(!showModal);
    };

    const handleChoice = (choice) => {
        if (choice == "C") {
            handleChange({
                target: {
                    checked: true
                }
            });
        }
        else {
            handleChange({
                target: {
                    checked:false
                }
            });
        }

        setShowModal(!showModal);
    };


    return (
        <div className="mb-1">
            <label className="switch" style={{ marginRight: 5 }}>
                <input type="checkbox" id={props.id} onChange={handleChange} disabled={props.disabled} checked={conditionChecked} />
                <span className="slider round"></span>
            </label>
            <label className="switch-text" onClick={handleTerms}>{props.label}</label>

            <ModalConditionsComponent show={showModal} handleClose={handleTerms} handleChoice={handleChoice} />

        </div>
    );
}

export default SwitchComponent;